<template>
	<div class="container">
		<div class="config_box" >
			<div class="title">
				后台数据配置页
			</div>
			<div class="btn" @click="submitInfoBtn">
				已完成全部配置，保存
			</div>
			<div class="info_box">
				<div class="left_box">
					<img src="../images/suolue.png" class="images">
					<div class="moduleOne" v-if="chooseIndex == 2 || chooseIndex == 3"><span>模块一</span></div>
					<div class="moduleTwo" v-if="chooseIndex == 1 || chooseIndex== 3"><span>模块二</span></div>
					<div class="moduleThree" v-if="chooseIndex == 1 || chooseIndex == 2"><span>模块三</span></div>
				</div>
				<div class="right_box">
					<div class="tab_box">
						<div :class="chooseIndex == 1 ? 'active' : ''" @click="chooseTab(1)">
							模块一
						</div>
						<div :class="chooseIndex == 2 ? 'active' : ''" @click="chooseTab(2)">模块二</div>
						<div :class="chooseIndex == 3 ? 'active' : ''" @click="chooseTab(3)">
							模块三
						</div>
					</div>
					<div class="config_info_one" v-if="chooseIndex == 1">
						<div class="">
							<span>主标题：</span><input type="text" v-model="submitInfo.title" name="" value="" style="border: 1px solid #ccc; width: 220px;height: 24px;"/>
						</div>
						<div v-for="(item, index) in submitInfo.one_values" :key='index'>
							<span>标题 {{ index + 1 }}：</span><input type="text" name="" v-model="item.item" value="" placeholder="请输入"/> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;"/>
						</div>
					</div>
					<div class="config_info_two" v-if="chooseIndex == 2">
						<div class="">
							<span style="font-size: 18px;">模块标题一：</span><input type="text" name="" value="" v-model="submitInfo.two_values.one_child_map.title" style="border: 1px solid #ccc; width: 220px;height: 24px;"/>
						</div>
						<div class="" style="margin-left: 38px;">
							<span>园区名称：</span><input type="text" name="" value="" v-model="submitInfo.two_values.one_child_map.park_name" style="border: 1px solid #ccc; width: 220px;height: 24px;"/>
						</div>
						<div class="flex_box">
							<div v-for="(item, index) in submitInfo.two_values.one_child_map.values" :key='index'>
								<span>标题{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;"/>
							</div>
						</div>
						<div class="" style="margin-left: 80px;">
							<span>门禁SN：</span><input type="text" name="" v-model="submitInfo.two_values.one_child_map.device_sns" value="" style="width: 500px;"/>
							<div class="tips">请输入门禁的SN最多输入十个；多个门禁请用英文逗号隔开。输入门禁SN后，自动获取并展示一下数据，不填写SN择不展示以下数据。</div>
						</div>
						
						<div class="" style="margin-top: 40px;">
							<span style="font-size: 18px;">模块标题三：</span><input type="text" name="" v-model="submitInfo.two_values.two_child_map.title" value="" style="border: 1px solid #ccc; width: 220px;height: 24px;"/>
						</div>
						<div class="tips">后台根据数值自动排名，无需考虑先后顺序</div>
						<div class="flex_box">
							<div v-for="(item, index) in submitInfo.two_values.two_child_map.values" :key='index'>
								<span>企业名称{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;"/>
							</div>
						</div>
					</div>
					<div class="config_info_three" v-if="chooseIndex == 3">
						<div class="one">
							<div class="left">
									表一
									<div class="tips" style="padding: 0 12px;">内部字段最多写8个，不写则不展示。保存后自动更新图表。</div>
							</div>
							<div class="right" style="flex: 1">
								<div class="" style="margin-left: 38px;">
									<span>图表名称：</span><input type="text" name="" value="" v-model="submitInfo.three_values.one_child_map.chart_name" style="width: 220px;height: 24px;"/>
								</div>
								<div class="flex_box" style="padding-left: 10px;margin-top: 2px">
									<div v-for="(item, index) in submitInfo.three_values.one_child_map.values" :key='index' style="margin-top: 8px;">
										<span>数据{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;width: 100px;"/>
									</div>
								</div>
							</div>
						</div>
						<div class="one">
							<div class="left">
									表二
									<div class="tips" style="padding: 0 12px;">内部字段最多写8个，不写则不展示。保存后自动更新图表。</div>
							</div>
							<div class="right" style="flex: 1">
								<div class="" style="margin-left: 38px;">
									<span>图表名称：</span><input type="text" name="" value="" v-model="submitInfo.three_values.two_child_map.chart_name" style="width: 220px;height: 24px;"/>
								</div>
								<div class="flex_box" style="padding-left: 10px;margin-top: 2px">
									<div v-for="(item, index) in submitInfo.three_values.two_child_map.values" :key='index' style="margin-top: 8px;">
										<span>数据{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;width: 100px;"/>
									</div>
								</div>
							</div>
						</div>
						<div class="one">
							<div class="left">
									表三
									<div class="tips" style="padding: 0 12px;">内部字段最多写8个，不写则不展示。保存后自动更新图表。</div>
							</div>
							<div class="right" style="flex: 1">
								<div class="" style="margin-left: 38px;">
									<span>图表名称：</span><input type="text" name="" value="" v-model="submitInfo.three_values.three_child_map.chart_name" style="width: 220px;height: 24px;"/>
								</div>
								<div class="flex_box" style="padding-left: 10px;margin-top: 2px">
									<div v-for="(item, index) in submitInfo.three_values.three_child_map.values" :key='index' style="margin-top: 8px;">
										<span>数据{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;width: 100px;"/>
									</div>
								</div>
							</div>
						</div>
						<div class="one">
							<div class="left">
									表四
									<div class="tips" style="padding: 0 12px;">内部字段最多写8个，不写则不展示。保存后自动更新图表。</div>
							</div>
							<div class="right" style="flex: 1">
								<div class="" style="margin-left: 38px;">
									<span>图表名称：</span><input type="text" name="" value="" v-model="submitInfo.three_values.four_child_map.chart_name" style="width: 220px;height: 24px;"/>
								</div>
								<div class="flex_box" style="padding-left: 10px;margin-top: 2px">
									<div v-for="(item, index) in submitInfo.three_values.four_child_map.values" :key='index' style="margin-top: 8px;">
										<span>数据{{ index + 1 }}：</span><input type="text" name="" value="" v-model="item.item" placeholder="请输入" /> <input type="text" name="" value="" v-model="item.count" style="margin-left: 20px;width: 100px;"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				chooseIndex: 1,
				submitInfo: {
				title: "",
				one_values: [
					{
						item: "",
						count: ''
					},
					{
						item: "",
						count: ''
					},
					{
						item: "",
						count: ''
					},
					{
						item: "",
						count: ''
					},
					{
						item: "",
						count: ''
					},
				],
				two_values: {
					one_child_map:{
						title: "",
						park_name: "",
						values: [
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
							],
							device_sns: ""
					},
					two_child_map:{
						title: "",
						values: [
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
								{
									item: "",
									count: ''
								},
							]
					}
				},
				three_values: {
					one_child_map:{
						chart_name: "",
						values: [
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							]
					},
					two_child_map:{
						chart_name: "",
						values: [
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							]
					},
					three_child_map:{
						chart_name: "",
						values: [
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							]
					},
					four_child_map:{
						chart_name: "",
						values: [
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							{
								item: "",
								count: ''
							},
							]
					}
				}
	}
			}
		},
		created() {
			this.getConfig()
			// if (window.localStorage.getItem('submitInfo')) {
			// 	this.submitInfo = JSON.parse(window.localStorage.getItem('submitInfo'))
			// } 
		},
		mounted() {
			
		},
		methods: {
			chooseTab(index) {
				this.chooseIndex = index
			},
			async getConfig() {
				const res = await API.getConfig()
				if (JSON.stringify(res.body) != '{}') {
					this.submitInfo = res.body
				}
				
			},
			async submitInfoBtn() {
				const res = await API.submitConfigInfo(this.submitInfo)
				alert('保存成功')
			}
		}
	}
</script>

<style scoped>
	body {
		margin: 0;
	}
	.title {
		width: 100%;
		text-align: left;
		font-size: 20px;
		color: black;
		font-weight: bold;
	}
	.container {
		width: 100vw;
		height: 100vh;
		background: #f5f5f5;
	}
	.config_box {
		padding: 15px;
		margin: 0 auto;
		width: 1650px;
		min-height: 600px;
		background: white;
		position: relative;
		top: 100px;
	}
	.info_box {
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
	}
	.left_box {
		flex: 5;
		position: relative;
	}
	.left_box .moduleOne {
		position: absolute;
		width: 825px;
		height: 96px;
		top: 0;
		left: 0;
		background-color: rgb(255,255,255, .4)
	}
	.left_box .moduleTwo {
		position: absolute;
		width: 190px;
		height: 339px;
		top: 105px;
		left: 0;
		background-color: rgb(255,255,255, .4)
	}
	.left_box .moduleThree {
		position: absolute;
		width: 367px;
		height: 340px;
		top: 105px;
		right: 0;
		background-color: rgb(255,255,255, .4)
	}
	.left_box .moduleOne span, .moduleTwo span, .moduleThree span {
		font-size: 18px;
		color: white;
		font-weight: bold;
		text-align: left;
		display: inline-block;
		width: 100%;
		padding: 10px;
	}
	.left_box .images {
		width: 100%;
		height: auto;
	}
	.right_box {
		flex: 5;
	}
	.tab_box {
		width: 100%;
		height: 35px;
		display: flex;
		justify-content: space-between;
	}
	.tab_box div {
		width: 33.333%;
		text-align: center;
	}
	.tab_box .active {
		font-size: 18px;
		color: #3889e7;
		font-weight: bold;
	}
	.config_info_one, .config_info_two {
		margin: 30px;
	}
	.config_info_one div, .config_info_two div {
		margin-top: 20px;
	}
	input {
		border: none;
		outline:none;
		border-bottom: 1px solid #ccc !important;
	}
	span {
		color: #113ea0;
		font-weight: bold;
	}
	
	.config_info_two div span {
		font-size: 14px;
		color: #113ea0;
		font-weight: bold;
	}
	.flex_box span {
		font-size: 14px;
		color: #113ea0;
		font-weight: bold;
	}
	.flex_box {
		padding-left: 80px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.tips {
		color: #666;
		font-size: 12px;
		margin-top: 8px !important; 
	}
	.one {
		display: flex;
		margin-top: 30px;
	}
	.one .left {
		width: 85px;
		height: 150px;
		border-right: 2px solid #787676;
		text-align: center;
		font-size: 16px;
		color: #113ea0;
		font-weight: bold;
	}
	.btn {
		cursor: pointer;
		position: absolute;
		top: 10px;
		right: 20px;
		width: 160px;
		height: 45px;
		text-align: center;
		line-height: 45px;
		background: #113ea0;
		color: white;
		font-size: 14px;
		border-radius: 2px;
	}
</style>
